import $ from 'jquery';
import { getInputValue } from '../utils/input';
const ELEMENT_SELECTOR = '.js__sum-field-values';
export class SumFieldValues {
    static init($root = $('body')) {
        const $elements = $root.find(ELEMENT_SELECTOR);
        if (!$elements.length) {
            return;
        }
        this.initHandleValueChange($elements);
    }
    static initHandleValueChange($elements) {
        $elements.each((index, element) => {
            const $element = $(element);
            const recalculateOnElementClick = $element.data('sum-calc-on-element-click');
            $($element.data('sum-fields')).on('keyup', event => {
                setTimeout(() => {
                    this.handleValueChange($element);
                });
            });
            $(recalculateOnElementClick).on('click', () => {
                setTimeout(() => {
                    $(recalculateOnElementClick).on('click', () => {
                        setTimeout(() => {
                            this.handleValueChange($element);
                        });
                    });
                    this.handleValueChange($element);
                });
            });
            this.handleValueChange($element);
        });
    }
    static handleValueChange($element) {
        const $target = $($element.data('sum-fields'));
        let sum = 0;
        $target.each((index, target) => {
            const inputValue = Number(getInputValue($(target))) || 0;
            sum = sum + inputValue;
            $element.val(sum.toFixed(2));
            $element.trigger('change');
        });
    }
}
